import React, { useEffect, useState } from 'react';
import { dateReadableFormat, timeFormatAMPM } from '../../common/dateTimeFuncs';
import { ASSIGNED, COMPLETED } from '../../common/Types';
import { DailyTaskI } from '../../interfaces/DailyTaskInterface';
import { useStore } from '../../store/store';
import './task.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faCheckCircle,
  faRedo,
  faTasks,
} from '@fortawesome/free-solid-svg-icons';
import { faCalendar } from '@fortawesome/free-regular-svg-icons';

export interface TaskProps {
  data: DailyTaskI;
  onDone?: Function;
}

const Task = (props: TaskProps) => {
  const { completedTask, updateTask } = useStore();
  const { key, taskStatus, priority, details, assignedDate, completedDate } =
    props.data;

  const [taskClass, setTaskClass] = useState<string>('');

  useEffect(() => {
    if (taskClass === '') return;

    const _setTaskTOFunc = setTimeout(() => {
      setTaskClass('');
    }, 800);

    return () => {
      clearTimeout(_setTaskTOFunc);
    };
  }, [taskClass]);

  if (!props.data) return <></>;

  return (
    <div
      className={`task-card__container ${taskClass}`}
      style={{
        backgroundColor:
          taskStatus === COMPLETED
            ? '#75ff75'
            : priority === '-1'
            ? 'lightgrey'
            : priority === '0'
            ? 'lightcyan'
            : '#ff7527',
      }}
    >
      <div className="task-card__item-container">
        <div className="task-card__item-header">
          <div>
            <FontAwesomeIcon
              icon={faTasks}
              style={{
                marginRight: '.5rem',
              }}
            />
            {details.pages ? 'Page: ' : 'Chapter: '}
            {details.pages || details.chapters}
          </div>
        </div>
        <div className="task-card__item">
          <div>
            <FontAwesomeIcon
              icon={faCalendar}
              style={{
                marginRight: '.5rem',
              }}
            />
            {dateReadableFormat(assignedDate)}
          </div>
          {completedDate && (
            <div>
              <FontAwesomeIcon
                icon={faCheckCircle}
                style={{
                  marginRight: '.5rem',
                }}
              />
              {timeFormatAMPM(completedDate)}
            </div>
          )}
        </div>
      </div>

      <div className="task-card__button-container">
        {!completedDate ? (
          <button
            className="task-card__button--done"
            onClick={() => {
              props.onDone && props.onDone();
              if (!key) return <></>;
              setTaskClass('task-completed');
              completedTask({ ...props.data });
            }}
          >
            <FontAwesomeIcon icon={faCheck} />
          </button>
        ) : (
          <button
            className="task-card__button--not-done"
            onClick={() => {
              props.onDone && props.onDone();
              if (!key) return <></>;
              setTaskClass('task-completed');
              updateTask({
                ...props.data,
                taskStatus: ASSIGNED,
                completedDate: null,
              });
            }}
          >
            <FontAwesomeIcon icon={faRedo} />
          </button>
        )}
      </div>
    </div>
  );
};

export default Task;
